<template>
  <img
    :class="{
      'arrow': true,
      'arrow--open': open
    }"
    src="./arrow.svg"
  >
</template>

<script>
export default {
  name: "DsArrow",
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

.arrow {
  display: block;
  width: 6px;
  height: 10px;
  transform: rotate(90deg);
  transition: $transition-duration;
  &--open {
    transition: $transition-duration;
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-arrow.vue